/** Events broadcasted between tabs via BroadcastChannel */
export enum AuthChannelEvent {
  TOKEN_REFRESHED = 'TOKEN_REFRESHED',
  LOGOUT = 'LOGOUT',
  ACTIVITY = 'ACTIVITY'
}

/** Session lifecycle states for SessionManager */
export enum SessionState {
  ACTIVE = 'ACTIVE',
  /** Network is down; timers paused; token not yet expired */
  OFFLINE_ACTIVE = 'OFFLINE_ACTIVE',
  /** Network is down AND absolute TTL has passed — unrecoverable */
  OFFLINE_EXPIRED = 'OFFLINE_EXPIRED',
  /** A refresh network call is in flight */
  REFRESHING = 'REFRESHING',
  TERMINATED = 'TERMINATED'
}

/** Force logout after 30 minutes of inactivity */
export const INACTIVITY_TIMEOUT_MS = 30 * 60 * 1000

/** Show "session expiring" warning modal after 28 minutes (2 min before logout) */
export const INACTIVITY_WARNING_MS = 28 * 60 * 1000

/** Refresh the access token 1 minute before JWT expiry */
export const REFRESH_BEFORE_EXPIRY_MS = 60 * 1000

/** Default absolute TTL for refresh token (12 hours) — used when user/company setting is absent */
export const DEFAULT_ABSOLUTE_TTL_SECONDS = 43200

/**
 * Maximum safe delay for setTimeout (2^31 - 1 ms ≈ 24.8 days).
 * Browsers store setTimeout delay as a signed 32-bit integer — values larger
 * than this overflow and fire immediately (as if delay = 0), which would
 * cause instant session termination when idleTimeoutSeconds is set to a
 * very large sentinel value (e.g. 999999999 = "disabled" on the backend).
 */
export const MAX_TIMEOUT_MS = 2147483647

/** Ignore rapid-fire DOM events — only process activity once per 30 seconds */
export const ACTIVITY_THROTTLE_MS = 30 * 1000

/** DOM events that count as user activity */
export const ACTIVITY_EVENTS = ['click', 'keypress', 'scroll', 'mousemove', 'touchstart'] as const
